<script>
  // import CardBase from '@/components/CardBase'

  import { computed } from '@nuxtjs/composition-api'

  export default {
    components: {
      // CardBase
    },
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    setup (props) {
      const url = computed(() => {
        return `/producten/${props.product.propellerId}/${props.product.slug}`
      })

      return {
        url
      }
    }
  }
</script>

<template>
  <nuxt-link
    :to="url"
    class="card-product-search py-8 py-8 flex content-center items-center transition-opacity hover:opacity-50"
  >
    <div class="flex items-center">
      <figure class="product-image w-24 mr-6">
        <img
          v-if="product.image"
          :src="product.image"
          :alt="product.name"
          class="mx-auto"
        >
      </figure>
      <header>
        <h3
          class="font-bold text-lg font-primary"
          :title="product.name"
        >
          <ais-highlight
            attribute="name"
            :hit="product"
          />
        </h3>
        <div class="flex items-center space-x-4 mt-2">
          <p class="text-gray-600">
            <ais-highlight
              attribute="productType"
              :hit="product"
            />
          </p>
          <template v-if="product.level">
            <div class="w-px h-4 bg-gray-600"></div>
            <p class="text-gray-600">
              <ais-highlight
                attribute="level"
                :hit="product"
              />
            </p>
          </template>
        </div>
      </header>
    </div>
  </nuxt-link>
</template>
